<footer id="page-footer" class="footer-wrapper">
    @defer (hydrate on viewport) {
        <section class="reinsurance">
            @if (supportInfos(); as supportInfos) {
                <h-reinsurance-footer [reinsuranceData]="supportInfos.footer"></h-reinsurance-footer>
            }
        </section>
        <section class="columns">
            @if (footerItems(); as footerItems) {
                <h-footer-columns
                    [socialNetworks]="footerItems.socialNetworks"
                    [columns]="footerItems.columns"></h-footer-columns>
            }
        </section>
        <div class="sub-footer">
            <hr />
            <h-sub-footer [legalLinks]="footerItems()?.legalLinks"></h-sub-footer>
            <div #parallaxTrigger class="parallax-trigger" aria-hidden="true"></div>
        </div>
    }
</footer>
